module.exports = __webpack_public_path__ + "static/media/folder-empty.7dd0e270.svg";